import React, { useContext, useState } from "react";
import "./Footer.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
function Footer({ elementId }) {
  const organizerName = window.location.pathname.split("/")[1];
  const campaignName = window.location.pathname.split("/")[2];
  const { guestModeEnabled, setPreviousLocation } = useUserAuth();
  const { campaignMetaData } = useContext(Context);
  const location = useLocation();

  const [element, setElement] = useState(elementId);
  const navigate = useNavigate();
  const handleShowcaseButonClick = (elements) => {
    setElement(elements);
    navigate(`/${organizerName}/${campaignName}/${elements}`);
  };
  return (
    <div className="h-[90px] w-[100%] footer flex items-center justify-center gap-[10px]">
      <button onClick={() => handleShowcaseButonClick("")}>
        <button
          className={
            element === "home" ? "footer-button" : "footer-button-showcase"
          }
        >
          Contests
        </button>
      </button>
      <button onClick={() => handleShowcaseButonClick("showcase")}>
        <button
          className={
            element === "showcase" ? "footer-button" : "footer-button-showcase"
          }
        >
          Showcase
        </button>
      </button>
      <button
        onClick={() => {
          if (guestModeEnabled) {
            setPreviousLocation(window.location.pathname);
            navigate(`/${campaignMetaData?.organizerName}/signup`, {
              state: { previousLocation: location?.pathname },
            });
          } else {
            handleShowcaseButonClick("profile");
          }
        }}
      >
        {
          <button
            className={
              element === "profile" ? "footer-button" : "footer-button-showcase"
            }
          >
            Profile
          </button>
        }
      </button>
    </div>
  );
}

export default Footer;
